const domain = String(process.env.REACT_APP_AUTH0_DOMAIN || '').replace(/^https?:\/\//, '').replace(/\/$/, '');
const clientId = process.env.REACT_APP_AUTH0_CLIENT_ID;
const audience = process.env.REACT_APP_AUTH0_AUDIENCE;
const connection = process.env.REACT_APP_AUTH0_CONNECTION || 'Username-Password-Authentication';

function configured() { return Boolean(domain && clientId && audience); }
async function request(path, body) {
  if (!configured()) throw new Error('Authentication configuration is incomplete.');
  const response = await fetch(`https://${domain}${path}`, {
    method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify(body),
  });
  const data = await response.json().catch(() => ({}));
  if (!response.ok) {
    const error = new Error(data.error_description || data.description || data.message || data.error || 'Authentication failed');
    error.code = data.error || data.code || 'AUTH0_ERROR';
    error.status = response.status;
    throw error;
  }
  return data;
}

export async function loginWithPassword(email, password) {
  return request('/oauth/token', {
    grant_type: 'http://auth0.com/oauth/grant-type/password-realm',
    client_id: clientId, username: String(email || '').trim().toLowerCase(), password,
    realm: connection, audience, scope: 'openid profile email',
  });
}
export async function signupWithPassword({ email, password, firstName, lastName }) {
  await request('/dbconnections/signup', {
    client_id: clientId, connection, email: String(email || '').trim().toLowerCase(), password,
    user_metadata: { firstName, lastName, name: `${firstName || ''} ${lastName || ''}`.trim() },
  });
  return loginWithPassword(email, password);
}
export const auth0Config = { domain, clientId, audience, connection, configured };
